import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ag-lock-column',
    templateUrl: './lock-column.component.html',
    styleUrls: ['./lock-column.component.scss'],
    standalone: false
})
export class LockColumnComponent implements OnInit {
  @Input() columnName: string;
  @Input() displayName: string;
  @Input() stickyColumns: string[];
  @Input() stickyEndColumns: string[];
  @Output() stickyColumnsChange = new EventEmitter<string[]>();

  constructor() {}

  ngOnInit(): void {}

  /** Whether the button toggle group contains the id as an active value. */
  isSticky(id: string) {
    return (this.stickyColumns || []).indexOf(id) !== -1;
  }

  isStickyEnd(id: string) {
    return (this.stickyEndColumns || []).indexOf(id) !== -1;
  }

  lockColumns(event: MouseEvent, columnName: string) {
    event.stopPropagation();

    const index = this.stickyColumns.indexOf(columnName, 0);
    if (index == -1) {
      this.stickyColumns.push(columnName);
    }

    if (index > -1) {
      this.stickyColumns.splice(index, 1);
    }
    this.stickyColumnsChange.emit(this.stickyColumns);
  }
}
